import React from 'react';
import styles from './styles.module.css';

const RangeSlider = ({
  register,
  id,
  placeholder,
  name,
  error,
  min,
  max,
  label,
  defaultValue,
  autocomplete,
  disabled,
  onChange,
  value,
}) => {
  return (
    <div className={styles.formGroup}>
      <label>{label}</label>
      <input
        ref={register}
        id={id}
        className={styles.slider}
        type="range"
        name={name}
        value={value}
        onChange={onChange}
        defaultValue={defaultValue}
        placeholder={placeholder}
        autoComplete={autocomplete}
        min={min}
        max={max}
        disabled={disabled}
      />
      {error && <div className={styles.error}>{error.message}</div>}
    </div>
  );
};

export default RangeSlider;
